import { ReactSortable } from "react-sortablejs";
import returnIcon from "../../../../../assets/img/modals/return.svg";
import { useState, useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { hideLoader, showLoader } from "../../../../loader";
import { apiUrl } from "../../../../../utils/url";
import FormFieldError from "../../../../errors/formFieldError";
import tickIconPrimary from "../../../../../assets/img/white-tick-icon.svg";
import ErrorMessage from "../../../../errors/errorMessage";
import CroppieModal from "../../../../croppie-modal";
import { toast } from "react-toastify";
import removeicon from "../../../../../assets/img/products/removeicon.svg";
import SelectedThemeInput from "../../../../custom-theme/commons/select-theme-input";
import SelectedCustomTheme from "../../../../custom-theme/commons/select-custom-theme";
import lightmodeicon from "../../../../../assets/img/products/lightmodeicon.svg";
import { Modal } from "react-bootstrap";
import closeIcon from "../../../../../assets/img/modals/close-icon.svg"
import dots from "../../../../../assets/img/Dots1.svg"
import { createFormdataValues } from "../../../../../utils/createFormdataValues";
import { audiencePosts } from "../../../../../services/postRequests/audience";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";

const ExportSteps = ({subscribers_length, show, setShow, product_id }) => {
    const [importType, setImportType] = useState("csv");
    const [uploadedFile, setUploadedFile] = useState(null);
    const refUpload = useRef(null);
    const history = useHistory(null);
    const [mappingFieldModal, setmappingFieldModal] = useState(false);
    const [subscribersName, setsubscribersName] = useState([])
    const [subscribersEmail, setsubscribersEmail] = useState([]);
    const [subscribersCompanyName, setsubscribersCompanyName] = useState([]);
    const [subscribersLength, setsubscribersLength] = useState();
    const [showExportModal, setShowExportModal] = useState(true);
    const [credits, setCredits] = useState(null);
    const { slug } = useSelector(state => state?.slugReducer);
    const [formValues, setformValues] = useState({
        subscriber_name_index: "0", subscriber_email_index: "0", subscriber_company_name_index: "0", project: slug, csv_file: null
    })
    const [error, setError] = useState([])

    const handleClose = () => {
        setUploadedFile(null);
        setShowExportModal(false);
        // setShow({show:false, from:null})
    }
    const toggleImportType = (type) => {
        setImportType(type);
    };
    const dropzoneWrapperClick = () => {
        refUpload.current?.click();
    }
    const dropzoneWrapperDrop = (e) => {
        e.preventDefault();
        e.stopPropagation();
        setUploadedFile(null)
        if (e.dataTransfer.files[0].type !== "text/csv")
            toast.error("Please select a CSV file");
        else setUploadedFile(e.dataTransfer.files)
    }
    const dropzoneWrapperDrag = (e) => {
        e.preventDefault();
        e.stopPropagation();
        $(e.target).addClass('dragover');
    }

    const dropzoneWrapperLeave = (e) => {
        e.preventDefault();
        e.stopPropagation();
        $(e.target).removeClass('dragover');
    }
    const handleChange = (e) => {
        setUploadedFile(e.target.files)
        uploadCSV(e)
    };
    const uploadCSV = (e) => {
        e.preventDefault();
        mappingFile(e.target.files)
    }
    const mappingFile = (files) => {
        showLoader();
        setError([])
        if (files?.length > 0) {
            
            var file = files[0];
            var reader = new FileReader();
            reader.readAsText(file);
            reader.onload = function (event) {
                var csv = event.target.result;
                var data = csv.split("\n");
                const csv_cols = data[0].split(",");
                if (csv_cols.length < 3) {
                    setUploadedFile(null);
                    toast.error("Please upload a CSV file with at least three columns: Name, Email, and Company Name");
                    hideLoader();
                    return;
                }
                setsubscribersName(csv_cols);
                setsubscribersEmail(csv_cols)
                setsubscribersCompanyName(csv_cols)
                setformValues({
                    ...formValues, csv_file: files[0],

                })
                if (data[0].includes(".com") === false) {
                    setsubscribersLength(data.length - 1);
                }else {
                    setsubscribersLength(data.length);
                }
                setTimeout(() => {
                    hideLoader()
                    setmappingFieldModal(true)
                    // setShow({show:false})
                    setShowExportModal(false);
                }, 300);
            }
            }
        else {
            toast.error("Please upload a csv file")
            hideLoader()
        }
    }
    const nextStep = () => {
        if (importType == 'manual') {
            if(!formValues.name || !formValues.company_name || !formValues.email){
                toast.error("Please fill all fields first");
                return;
            }
            setsubscribersLength(1);
        }
        $('#importLeads').removeClass('active show');
        $('#btnPageProfile2').removeClass('active show');
        $('#generate').addClass('active show');
        $('#btnPageTheme').addClass('active show');
    };
    const handleSubmit = (e = null,from = null) => {
        if (e && typeof e.preventDefault === 'function') {
            e.preventDefault();
        }
        showLoader()
        const api = apiUrl + "/community/subscribers/import";

        const formData = createFormdataValues(formValues);
        console.log("formData",formValues)
        const myHeaders = new Headers();
        myHeaders.append("Authorization", `Bearer ${localStorage?.getItem("token")}`)
        if (importType == 'manual') {
            formData.append("from",'manually')
        }
        console.log("from",from)
        formData.append("campaign",product_id)
        const setOptions = {
            headers: myHeaders,
            body: formData,
            method: 'POST'
        }

        const errorList = []
        
        fetch(api, setOptions).then(async (res) => {
            const response = await res.json();
            if (response?.status_code == 200) {
                toast?.success(response?.status_message);
                hideLoader();
                setShowExportModal(true);
                setmappingFieldModal(false);
                // callAudience();
                setsubscribersLength(response?.data?.subscribersCount)
                setCredits(response?.data?.credits)
            } else {
                if (response?.errors?.csv_file?.length > 0)
                {
                    errorList.push(response?.errors?.csv_file);
                    setError(errorList);
                }else{
                    setError(Object.values(response?.errors));
                    if (Object.keys(response?.errors).length > 0)
                      $(".modal-body").scrollTop(0);
                }
                toast?.error(response?.status_message)
                hideLoader();
            }
        }).catch((error) => {
            toast?.error(error)
            hideLoader()

        })

    }
    const handleManuallyChange = (e) => {
        setformValues({ ...formValues, [e.target.name]:e.target.value});
    };
    const exportCSV = () => {
        showLoader();
        const api = apiUrl + "/community/subscribers/export";
        const formdata = createFormdataValues(formValues);
        formdata.append("project", slug)
        formdata.append("campaign",product_id)
        if (importType == 'manual') {
            formdata.append("from",'manually')
        }
        var myHeaders = new Headers();
        myHeaders.append("Authorization", `Bearer ${localStorage?.getItem("token")}`);
        const setOptions = {
            method: "POST",
            headers: myHeaders,
            body: formdata
        }
        audiencePosts(api, hideLoader, setOptions, "export").then((response) => {
            setShow(false)
            history.push("/project/" + slug + "/leads");
        }).catch((err) => {
            toast.error(err)
        })
            
    }
    const handleCloseMapModal = () => {
        setUploadedFile(null)
        setmappingFieldModal(false);
    };
    const handleChangeSelect = (e) => setformValues({ ...formValues, [e.target.name]: e.target.value });
    const saveMapData = () => {
        setmappingFieldModal(false);
        setShowExportModal(true);
    };
    useEffect(()=>{
        if (show?.show && !mappingFieldModal) {
            setShowExportModal(true);
            setImportType("csv")
        }
    },[show])
    console.log("setImportType",importType)
    return (
        <>
        <Modal className="customizeExportModal"
            show={showExportModal} onHide={handleClose} size={"lg"} id="customizePageModal">
            <div class="modal-dialog-centered modal-xlarge" role="document">
                <div class="modal-content p-0">

                    <div class="modal-body p-0">

                    <div class="customize-page-desktop customize-export-modal custom-u">
                        <button class="btn close-btn" data-bs-dismiss="modal" onClick={handleClose}>
                            <img src={closeIcon} width="15px" alt="" />
                        </button>
                        <div className="fade-u"></div>

                        <div class="left-bar nav nav-tabs export-nav-bar" role="tablist">
                            <div className="export-modal-menus flex-column  d-flex">
                                <div class="customize-page-menu-link active custom-width-u customizePageProfile" id="btnPageProfile2" >
                                    <div class="counter">1</div>
                                    <h6 class="pt-1 mb-0 ms-2">Import Leads</h6>
                                </div>
                                <div class="customize-page-menu-link custom-width-u customizePageTheme" id="btnPageTheme" >
                                    <div class="counter">2</div>
                                    <h6 class="pt-1 mb-0 ms-2">Generate + Download</h6>
                                </div>
                            </div>
                            <div className="export-modal-dots-image" style={{padding:"0 20px"}}>
                                <img width={"100%"} src={dots} alt="" />
                            </div>
                        </div>
                        <div class="tab-content position-relative ">
                            <div class="tab-pane fade active show p20-u" id="importLeads" role="tabpanel" aria-labelledby="btnPageProfile2">
                                <section>
                                    <h4 className="productHead1">Import Leads</h4>
                                    <div className="form-group w-100 p-0 mt-3">
                                        <label className="productlabels">Import</label>
                                        <div className="d-flex justify-content-between up-in-toggle bg-white import-leads price_type_check mt-2 p-0">
                                            <input type="radio" id="switch_left" name="importType" defaultChecked value="csv" onChange={() => toggleImportType("csv")} />
                                            <label htmlFor="switch_left" className="d-flex align-items-start flex-column w-50">
                                                <span className="w-100 d-flex align-items-center justify-content-between">
                                                    <h5 className="m-0 font-weight-500 pricing-text productlabel2">Upload CSV</h5>
                                                </span>
                                                <h6 className="productlabel3">Upload bulk leads</h6>
                                            </label>
                                            <input type="radio" id="switch_right" name="importType" value="manual" onChange={() => toggleImportType("manual")} />
                                            <label htmlFor="switch_right" className="d-flex align-items-start flex-column w-50">
                                                <span className="w-100 d-flex align-items-center justify-content-between">
                                                    <h5 className="m-0 font-weight-500 pricing-text productlabel2">Enter Manually</h5>
                                                </span>
                                                <h6 className="productlabel3">Enter Manually</h6>
                                            </label>
                                        </div>
                                    </div>
                                    <div className="form-group w-100 p-0 mt-3">
                                    <ErrorMessage error={error} />
                                    {
                                    importType == 'csv' ? 
                                    <>
                                        <div className="productlabels">Upload file</div>
                                        {!uploadedFile ?<>
                                        <input type="file" class="d-none dropzone" name="csv_file" ref={refUpload} accept=".csv" onChange={handleChange} />
                                        <button onClick={dropzoneWrapperClick} onDragOver={dropzoneWrapperDrag} onDragLeave={dropzoneWrapperLeave} onDrop={dropzoneWrapperDrop} type="button" class="project-upload-button">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
                                            <path fill-rule="evenodd" clip-rule="evenodd" d="M6 0C6.41421 0 6.75 0.335786 6.75 0.75V5.25H11.25C11.6642 5.25 12 5.58579 12 6C12 6.41421 11.6642 6.75 11.25 6.75H6.75V11.25C6.75 11.6642 6.41421 12 6 12C5.58579 12 5.25 11.6642 5.25 11.25V6.75H0.75C0.335786 6.75 0 6.41421 0 6C0 5.58579 0.335786 5.25 0.75 5.25H5.25V0.75C5.25 0.335786 5.58579 0 6 0Z" fill="#333333"/>
                                            </svg>
                                            <span class="upload-text">Upload New</span>
                                        </button></>
                                        :
                                            <small>{uploadedFile[0]?.name}</small>
                                        }
                                    </>
                                    :
                                    <>
                                        <div className="d-flex flex-column gap-2 ">
                                            <input
                                                type="text"
                                                className="zaapGlobal-input"
                                                onChange={(e)=>handleManuallyChange(e)}
                                                name="name"
                                                placeholder="Lead Name"
                                                value={formValues?.name}
                                            />
                                            <input
                                                type="email"
                                                className="zaapGlobal-input"
                                                onChange={(e)=>handleManuallyChange(e)}
                                                name="email"
                                                placeholder="Lead Email"
                                                value={formValues?.email}
                                            />
                                            <input
                                                type="text"
                                                className="zaapGlobal-input"
                                                onChange={(e)=>handleManuallyChange(e)}
                                                name="company_name"
                                                placeholder="Company Name"
                                                value={formValues?.company_name}
                                            />
                                        </div>
                                    </>

                                    }
                                    </div>
                                    <div class="text-center mt-4 d-flex submit-buttons-fixed">
                                    <button type="button" onClick={(e) =>nextStep()} className="project-blue-btn">
                                            <b class="me-2 productlabel2">Next Step</b>
                                            <small class="project-blue-btn-badge">
                                                <img src={returnIcon} alt="" />
                                            </small>
                                        </button>
                                    </div>
                                </section>
                            </div>
                            <div class="tab-pane fade p20-u" id="generate" role="tabpanel" aria-labelledby="btnPageTheme">
                                <section>
                                    <h4 className="productHead1">Generate + Download</h4>
                                    <div className="form-group w-100 p-0 mt-3">
                                        <div className="generate-download">
                                            <div>This export will use</div>
                                            <div className="btn-gradient">{subscribersLength} Credits</div>
                                            <div>You Have {credits} Credits Remianing</div>
                                        </div>
                                    </div>
                                    <div class="text-center mt-4 d-flex submit-buttons-fixed">
                                        <button onClick={exportCSV} type="button" class="project-blue-btn w-100">
                                            <b class="me-2 productlabel2">Export + Download</b>
                                            <small class="project-blue-btn-badge">
                                                <img src={returnIcon} alt="" />
                                            </small>
                                        </button>
                                    </div>
                                </section>
                            </div>
                        </div>

                    </div>

                    </div>

                </div>
            </div>
        </Modal>
        <Modal centered show={mappingFieldModal} onHide={handleCloseMapModal} className="import-modal">
            <div class="modal-content pt-0 pl-0 pr-0 pb-0">
                <div class="modal-header create-biolink-header">
                    <h5 class="modal-title create-biolink-heading">Map CSV Fields</h5>
                    <button type="button" class="close" onClick={handleCloseMapModal} aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>

                <div class="modal-body">
                    <form name="import_subscribers_form" id="import_subscribers_form">
                        <div class="notification-container"></div>
                        <ErrorMessage error={error} />
                        <div class="form-group">
                            <label>Lead Name:</label>
                            <select name="subscriber_name_index" class="zaapGlobal-input" id="" required onChange={handleChangeSelect} selected={formValues.subscriber_name_index} >
                                {subscribersName.length > 0 && (
                                    subscribersName?.map((val, index) => (
                                        <option key={index} value={index}>{val}</option>
                                    ))
                                )}
                            </select>
                        </div>
                        <div class="form-group my-3">
                            <label>Lead Email:</label>
                            <select name="subscriber_email_index" class="zaapGlobal-input" id="" required onChange={handleChangeSelect} selected={formValues.subscriber_email_index} >
                                {subscribersEmail.length > 0 && (
                                    subscribersEmail?.map((val, index) => (
                                        <option key={index} value={index}>{val}</option>
                                    ))
                                )}

                            </select>
                        </div>
                        <div class="form-group">
                            <label>Company Name:</label>
                            <select name="subscriber_company_name_index" class="zaapGlobal-input" id="" required onChange={handleChangeSelect} selected={formValues.subscriber_company_name_index} >
                                {subscribersCompanyName.length > 0 && (
                                    subscribersCompanyName?.map((val, index) => (
                                        <option key={index} value={index}>{val}</option>
                                    ))
                                )}

                            </select>
                        </div>
                        <div class="text-center mt-4 d-flex justify-content-start gap-1" >
                            <button type="button" onClick={handleCloseMapModal} class="project-grey-button">
                                Cancel
                                <small className="exit-badge">Esc</small>    
                            </button>
                            <button type="button" onClick={saveMapData} name="submit" class="project-blue-btn">
                                <span class="productlabel2">Continue</span>
                                <small class="project-blue-btn-badge">
                                    <img src={returnIcon} alt="" />
                                </small>
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </Modal>
    </>
    )
}
export default ExportSteps